import { Formation } from "../types"

export const posfor3as: Formation = {
  id: "posfor3as",
  name: "3",
  category: "6 - 5",
  snapshots: [
    {
      players: [
        {
          x: 5.1246139362294185,
          y: 4.874945254308776
        },
        {
          x: 7.3966404084236395,
          y: 7.047455636119045
        },
        {
          x: 10.600865317359478,
          y: 5.697441602408388
        },
        {
          x: 8.135146821271562,
          y: 3.5520286970241095
        },
        {
          x: 12.647026800340223,
          y: 3.0812509917301374
        },
        {
          x: 0.8031445939623469,
          y: 2.601504636921763
        }
      ],
      opponents: [
        {
          x: 5.984169689985159,
          y: 5.509839421389636
        },
        {
          x: 8.468368147436436,
          y: 4.753818124568306
        },
        {
          x: 9.308335371484608,
          y: 3.3108414771878736
        },
        {
          x: 7.0055720831758235,
          y: 3.1870555809321797
        },
        {
          x: 4.325500105444249,
          y: 3.3841895282339736
        }
      ],
      ball: {
        x: 8.2590414979267,
        y: 6.765839297569212
      },
      goalkeepers: [
        {
          x: 7.079437073556041,
          y: 1.087305340145936
        }
      ]
    }
  ]
}
